export default __webpack_public_path__ + "static/media/quiz-background-small.73133d23.jpg";